/**
 * PlusTV 广场列表 GET /squarelist
 */

import api from '@/utils/api'

const TV_ROW_GRADIENTS = [
  'from-slate-800 to-slate-950',
  'from-blue-950 to-slate-950',
  'from-violet-950 to-slate-950',
  'from-cyan-950 to-slate-950'
]

function assertApiOk(res) {
  if (res == null || typeof res !== 'object') return
  const c = res.code
  if (c === undefined || c === null) return
  const n = Number(c)
  if (n === 0 || n === 200) return
  const msg = res.message || res.msg || res.error || `接口 code=${c}`
  throw new Error(msg)
}

function unwrapSquareList(res) {
  if (res == null) return []
  if (Array.isArray(res)) return res
  if (Array.isArray(res.list)) return res.list
  const d = res.data
  if (Array.isArray(d)) return d
  if (d && typeof d === 'object') {
    if (Array.isArray(d.list)) return d.list
    if (Array.isArray(d.items)) return d.items
    if (Array.isArray(d.records)) return d.records
  }
  return []
}

/**
 * @param {object} item
 * @param {number} index
 */
export function mapSquareListItem(item, index = 0) {
  const title = item.title != null ? String(item.title) : ''
  const rawName =
    item.name ||
    item.user_name ||
    item.nickname ||
    item.author_name ||
    (item.user && (item.user.name || item.user.nickname)) ||
    ''
  const userLabel = rawName ? String(rawName) : '用户'
  const userHandle = rawName
    ? rawName.startsWith('@')
      ? rawName
      : `@${rawName}`
    : '@用户'
  const tags = Array.isArray(item.tags) ? item.tags : []
  const tagLabel =
    (tags[0] != null && String(tags[0])) ||
    item.activity_type_text ||
    item.category_name ||
    '影视'
  const desc =
    item.desc != null
      ? String(item.desc)
      : item.subtitle != null
        ? String(item.subtitle)
        : item.description != null
          ? String(item.description)
          : ''
  return {
    id: item.id != null ? String(item.id) : item.uuid || `sq-${index}`,
    title,
    desc,
    thumb: item.thumb || item.cover || item.image || '',
    videoUrl: item.video_url || item.url || '',
    userLabel: String(userLabel),
    userHandle: String(userHandle),
    userAvatar:
      item.headimg ||
      item.user_avatar ||
      (item.user && item.user.headimg) ||
      '',
    tagLabel: String(tagLabel),
    gradientCls: TV_ROW_GRADIENTS[index % TV_ROW_GRADIENTS.length]
  }
}

/** 占位卡片（接口无数据或加载前） */
export function defaultTvRowPlaceholders(count = 4) {
  return Array.from({ length: count }, (_, i) => ({
    id: `placeholder-${i}`,
    title: '',
    thumb: '',
    videoUrl: '',
    userLabel: '用户',
    userHandle: '@用户',
    userAvatar: '',
    tagLabel: '影视',
    gradientCls: TV_ROW_GRADIENTS[i % TV_ROW_GRADIENTS.length],
    placeholder: true
  }))
}

/**
 * @param {{ page?: number, limit?: number }} opts
 */
export async function fetchSquareList(opts = {}) {
  const params = {
    page: opts.page ?? 1,
    limit: opts.limit ?? 8,
    ...(opts.extra || {})
  }
  const res = await api.get('/squarelist', { params })
  assertApiOk(res)
  const raw = unwrapSquareList(res)
  const d =
    res && typeof res === 'object' && res.data && typeof res.data === 'object' && !Array.isArray(res.data)
      ? res.data
      : {}
  const list = raw.map((item, i) => {
    const mapped = mapSquareListItem(item, i)
    return { ...mapped, placeholder: false }
  })
  return {
    list,
    currentPage: Number(d.current_page ?? d.page) || params.page,
    pageTotal: Number(d.page_total ?? d.last_page) || 1,
    itemTotal: Number(d.item_total ?? d.total) || raw.length
  }
}
